import { AuthCodeFlowPkce } from '@org-avp/classic-abi-authcode-pkce-js';
import { ROUTES } from './_constants';
import Server from './config/_server';

export const auth = new AuthCodeFlowPkce({
    authorizeEndpoint: Server.authorizeEndpoint,
    tokenEndpoint: Server.tokenEndpoint,
    clientId: Server.clientId,
    redirectUri: `${window.location.origin}${ROUTES.CONNECT}`,
    logoutEndpoint: Server.logoutEndpoint,
    logoutRedirectUri: window.location.origin,
    scope: 'openid'
  });